import request from './request';

export function getSalesforceUser(id) {
  return request({
    path: `/v1/salesforce/users/${id}`,
  });
}
